const HOME_SOFTWARE_FEATURE_LIST_RU = [
  '3D-моделирование интерьеров',
  'Дизайн интерьера',
  'Визуализация интерьера',
  'Создание дизайн проекта',
  'Автоматическая спецификация проекта',
  'Развертки стен, пола и потолка',
  'Технические планы и чертежи',
  'Настройка освещения',
  'Виртуальные туры',
  'Создание мудбордов',
  'Создание сметы',
  'Облачный рендеринг',
  'Библиотека моделей и материалов',
  'Импорт и редактирование 3D-моделей',
  'Импорт текстур',
  'Возможность работать в команде',
];

const HOME_WEBPAGE_CONTENT_RU = {
  name: 'Планоплан — программа для дизайна интерьера, проектирования и планировки дома, 3D планировщик квартир — скачивайте онлайн, бесплатный пробный период',
  description:
    'Планоплан – программа для 3D-визуализации интерьера и планировок квартиры и дома. 2D-планы и чертежи. Скачивайте и пробуйте бесплатно, действует 7-дневный пробный период.',
};

const buildFaqJsonLd = (faqData = []) => {
  if (!faqData.length) return null;

  return {
    '@type': 'FAQPage',
    'mainEntity': faqData.map(({ form_data = {} }) => ({
      '@type': 'Question',
      'name': form_data.question,
      'acceptedAnswer': { '@type': 'Answer', 'text': form_data.answer },
    })),
  };
};

export const getHomeJsonLd = ({ hostname, locale, title, description, faqData }) => {
  const JSON_LD_LANGUAGE_MAP = { ru: 'ru-RU', en: 'en-US', de: 'de-DE', es: 'es-ES' };
  const baseUrl = `https://${hostname}/${locale}/`;
  const orgId = `${baseUrl}#organization`;
  const websiteId = `${baseUrl}#website`;
  const webpageId = `${baseUrl}#webpage`;
  const softwareId = `${baseUrl}#software`;
  const isRu = locale === 'ru';
  const siteName = isRu ? 'Планоплан' : 'Planoplan';

  const graph = [
    {
      '@type': 'Organization',
      '@id': orgId,
      'logo': { '@type': 'ImageObject', 'url': `https://${hostname}/static/favicons/favicon-180x180.png` },
      'sameAs': [
        'http://t.me/planoplaneditor',
        'https://max.ru/id7806477024_biz',
        'https://vk.com/planoplan',
        'https://www.pinterest.com/planoplan3d/',
        'https://www.youtube.com/@planoplanru',
        'https://rutube.ru/channel/42506449/videos/',
      ],
    },
    {
      '@type': 'WebSite',
      '@id': websiteId,
      'url': baseUrl,
      'name': siteName,
      description,
      'publisher': { '@id': orgId },
    },
    {
      '@type': 'WebPage',
      '@id': webpageId,
      'url': baseUrl,
      'name': isRu ? HOME_WEBPAGE_CONTENT_RU.name : title,
      'description': isRu ? HOME_WEBPAGE_CONTENT_RU.description : description,
      'inLanguage': JSON_LD_LANGUAGE_MAP[locale] || JSON_LD_LANGUAGE_MAP.en,
      'isPartOf': { '@id': `https://${hostname}/#website` },
      'about': { '@id': softwareId },
      'primaryImageOfPage': {
        '@type': 'ImageObject',
        'url': `https://${hostname}/images/og/planoplan-home-1200x630.jpg`,
      },
    },
    {
      '@type': 'SoftwareApplication',
      'name': siteName,
      description,
      'url': baseUrl,
      'applicationCategory': 'DesignApplication',
      'operatingSystem': 'Windows 10, Windows 11, macOS (Intel and Apple Silicon)',
      'author': { '@type': 'Organization', '@id': orgId },
      'publisher': { '@type': 'Organization', '@id': orgId },
      'downloadUrl': `${baseUrl}download/`,
      ...(isRu ? { featureList: HOME_SOFTWARE_FEATURE_LIST_RU } : {}),
    },
  ];

  const faqJsonLd = buildFaqJsonLd(faqData);

  if (faqJsonLd) graph.push(faqJsonLd);

  return { '@context': 'https://schema.org', '@graph': graph };
};

export const getJsonLd = ({ type = [], hostname, locale, title, description, faqData, content = {} }) => {
  const languageMap = { ru: 'ru-RU', en: 'en-US', de: 'de-DE', es: 'es-ES' };
  const baseUrl = `https://${hostname}/${locale}/`;
  const orgId = `${baseUrl}#organization`;
  const websiteId = `${baseUrl}#website`;
  const webpageId = `${baseUrl}#webpage`;
  const softwareId = `${baseUrl}#software`;
  const isRu = locale === 'ru';
  const siteName = isRu ? 'Планоплан' : 'Planoplan';

  const graph = [];

  if (type.includes('organization')) {
    graph.push({
      '@type': 'Organization',
      '@id': orgId,
      'logo': { '@type': 'ImageObject', 'url': `https://${hostname}/static/favicons/favicon-180x180.png` },
      'sameAs': [
        'http://t.me/planoplaneditor',
        'https://max.ru/id7806477024_biz',
        'https://vk.com/planoplan',
        'https://www.pinterest.com/planoplan3d/',
        'https://www.youtube.com/@planoplanru',
        'https://rutube.ru/channel/42506449/videos/',
      ],
    });
  }

  if (type.includes('website')) {
    graph.push({
      '@type': 'WebSite',
      '@id': websiteId,
      'url': baseUrl,
      'name': siteName,
      description,
      'publisher': { '@id': orgId },
    });
  }

  if (type.includes('webpage')) {
    graph.push({
      '@type': 'WebPage',
      '@id': webpageId,
      'url': baseUrl,
      'name': isRu ? content.webpage.nameRu ?? title : content.webpage.nameEn ?? title,
      'description': isRu ? content.webpage.descriptionRu ?? description : content.webpage.descriptionEn ?? description,
      'inLanguage': languageMap[locale] || languageMap.en,
      'isPartOf': { '@id': `https://${hostname}/#website` },
      'about': { '@id': softwareId },
      'primaryImageOfPage': {
        '@type': 'ImageObject',
        'url': `https://${hostname}/images/og/planoplan-home-1200x630.jpg`,
      },
    });
  }

  if (type.includes('software')) {
    graph.push({
      '@type': 'SoftwareApplication',
      'name': siteName,
      description,
      'url': baseUrl,
      'applicationCategory': 'DesignApplication',
      'operatingSystem': 'Windows 10, Windows 11, macOS (Intel and Apple Silicon)',
      'author': { '@type': 'Organization', '@id': orgId },
      'publisher': { '@type': 'Organization', '@id': orgId },
      'downloadUrl': `${baseUrl}download/`,
      ...(isRu
        ? content.software.featureListRu && { featureList: content.software.featureListRu }
        : content.software.featureListEn && { featureList: content.software.featureListEn }),
    });
  }

  if (type.includes('faq')) {
    const faqJsonLd = buildFaqJsonLd(faqData);
    if (faqJsonLd) graph.push(faqJsonLd);
  }

  return { '@context': 'https://schema.org', '@graph': graph };
};

export const getStructuredDataScript = ({ type = [], hostname, locale, title, description, faqData, content = {} }) => {
  const jsonLd = getJsonLd({ type, hostname, locale, title, description, faqData, content });
  return `<script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: ${JSON.stringify(jsonLd).replace(/</g, '\\u003c')} }}
          />`;
};
